import React from "react";

function Achivement() {
  return (
    <div>
      <div className="award-style-one-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Achivement &amp; Awards</h4>
                <h2 className="title split-lines">
                  Transforming Ideas Into Impact Since 2018
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="award-style-one-items">
                {/* 2018 */}
                <div className="award-style-one-item hover-active-item reveal-up">
                  <div className="image-wrapper">
                    <img
                      src="assets/img/thumb/foundation_of_image.png"
                      alt="Foundation"
                    />
                  </div>
                  <div className="sub-title-one">
                    <h3>Foundation</h3>
                  </div>
                  <div className="info">
                    <p>
                      Founded with a vision to deliver innovative digital
                      solutions, helping startups and businesses build strong
                      technology foundations
                    </p>
                  </div>
                  <div className="year">
                    <h2>2018</h2>
                  </div>
                </div>

                {/* 2020 */}
                <div className="award-style-one-item hover-active-item active reveal-up">
                  <div className="image-wrapper">
                    <img
                      src="assets/img/thumb/blockchain_web3_01.png"
                      alt="Blockchain"
                    />
                  </div>
                  <div className="sub-title-one">
                    <h3>Blockchain & Web3 Expansion</h3>
                  </div>
                  <div className="info">
                    <p>
                      Expanded into blockchain development, delivering smart
                      contracts, crypto platforms, and decentralized
                      applications for global clients
                    </p>
                  </div>
                  <div className="year">
                    <h2>2020</h2>
                  </div>
                </div>

                {/* 2023 */}
                <div className="award-style-one-item hover-active-item reveal-up">
                  <div className="image-wrapper">
                    <img src="assets/img/thumb/ai.jpg" alt="AI" />
                  </div>
                  <div className="sub-title-one">
                    <h3>AI & Automation Launch</h3>
                  </div>
                  <div className="info">
                    <p>
                      Introduced AI-powered automation, intelligent chatbots,
                      and business process optimization solutions
                    </p>
                  </div>
                  <div className="year">
                    <h2>2023</h2>
                  </div>
                </div>

                {/* 2025 */}
                <div className="award-style-one-item hover-active-item reveal-up">
                  <div className="image-wrapper">
                    <img src="assets/img/thumb/ai_agent.png" alt="Future" />
                  </div>
                  <div className="sub-title-one">
                    <h3> AI Agents & Enterprise Systems</h3>
                  </div>
                  <div className="info">
                    <p>
                      Advancing into AI agents, CRM/ERP systems, and scalable
                      enterprise infrastructure
                    </p>
                  </div>
                  <div className="year">
                    <h2>2025</h2>
                  </div>
                </div>

                {/* 2026 */}
                <div className="award-style-one-item hover-active-item reveal-up">
                  <div className="image-wrapper">
                    <img src="assets/img/thumb/innovation.png" alt="Future" />
                  </div>
                  <div className="sub-title-one">
                    <h3>Expansion & Innovation</h3>
                  </div>
                  <div className="info">
                    <p>
                      Driving growth through AI innovation, global partnerships,
                      and next-generation blockchain solutions
                    </p>
                  </div>
                  <div className="year">
                    <h2>2026</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Achivement;
